import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_OUTCOMES_LIST = "GET_OUTCOMES_LIST";

export const service = async (data) => {
  const isShowTermedOutcomes=data.isShowTermedOutcomes!==undefined?data.isShowTermedOutcomes:true;
  const options: object = {
    url: `/Api/Outcome/GetOutcomeList?isShowTermedOutcomes=` + isShowTermedOutcomes,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_OUTCOMES_LIST, service, mock);
